export default {
  setModalOpener(value) {
    this.modalOpener = value;
  },

  openHostModal() {
    if (this.modalOpener) {
      this.modalOpener();
    }
  }
};
